import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Menu } from 'src/app/asistente-en-linea/models/Menu';
import { AuthService } from '../../auth/auth.service';
import { AreaFuncionalGAFU } from '../../models/area-funcional-gafu';
import { Role } from '../../models/role';
import { MenuService } from '../menu/menu.service';
import { AsistenteMenuService } from './asistente-menu.service';

@Component({
  selector: 'app-asistente-menu',
  templateUrl: './asistente-menu.component.html',
  styleUrls: ['./asistente-menu.component.scss']
})
export class AsistenteMenuComponent implements OnInit {
  cargandoDatos: boolean;
  menuSeleccionado: Menu;
  descripcion: string = "";
  nombre: string = "";
  codigoAsistente: string = "";
  habilitado: boolean = false;
  areasFuncionalesGAFU: AreaFuncionalGAFU[];
  areaFuncionalSeleccionada: AreaFuncionalGAFU;
  gafuAreaFuncional: string;
  loading: boolean = false;
  error: string;
  errorValidacionCreacionMenu: boolean;
  esUsuarioAdminitrador: boolean;
  EsEdicion: boolean = false;
  idMenu: string;
  idMenuBD: string;
  areaFuncional: string;

  constructor(private asistenteMenuService: AsistenteMenuService, private route: ActivatedRoute, private router: Router, private authService: AuthService, private menuService: MenuService) {
    this.errorValidacionCreacionMenu = false;
    this.esUsuarioAdminitrador = false;
  }

  myOptionsAreasFunciones: { label: string; value: string }[] = [];

  ngOnInit() {
    this.areasFuncionalesGAFU = [];

    this.esUsuarioAdminitrador = this.authService.esAdministrador();

    if (!this.esUsuarioAdminitrador) {
      this.areasFuncionalesGAFU.push(new AreaFuncionalGAFU("Acceso a todas las areas funcionales", "*", "Todos"));
      for (let area of this.authService.getUser().areasFuncionales) {
        this.areasFuncionalesGAFU.push(area);
      }
    }

    this.myOptionsAreasFunciones = this.areasFuncionalesGAFU.map((a: AreaFuncionalGAFU) => ({ label: a.descripcion, value: a.areaFuncional }));

    this.route.queryParamMap.subscribe((params: any) => {
      if (params.params.idMenu) {
        this.EsEdicion = true;
        this.idMenu = params.params.idMenu;
        this.idMenuBD = this.idMenu;
        this.loadMenu(this.idMenu);
      }
    })
  }

  irPaginaInicio() {
    this.router.navigate(['/config/home/']);
  }

  cancelOperation() {
    this.irPaginaInicio();
  }

  async applyOperation() {
    this.error = '';
    let resArray = [];
    this.errorValidacionCreacionMenu = false;
    if (this.isCreateMenuDataValid()) {
      this.loading = true;
      let idDest;
      let idDestFin = 0;

      if (this.EsEdicion) {
        resArray.push(await this.asistenteMenuService.actualizarMenu(this.codigoAsistente, this.idMenu, this.descripcion, this.nombre, this.areaFuncional,
          this.authService.getUser().username, this.habilitado).toPromise().catch((err) => {
            this.loading = false;
            this.error = err.message;
          }));
      } else {
        resArray.push(await this.asistenteMenuService.agregarMenu(this.codigoAsistente, this.descripcion, this.nombre, this.areaFuncional, this.authService.getUser().username).toPromise().catch((err) => {
          this.loading = false;
          this.error = err.message;
        }));
      }

      let noErr = resArray.reduce((previous, current) => {
        idDest = current.id;
        return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
      }, true)
      if (idDest) {
        idDestFin = Number(idDest);
      }
      if (noErr) {
        if (idDestFin < 0) {
          if (idDest === '-1') {
            this.error = "Atención: Ya existe otro menú con el mismo identificador";
          } else if (idDest === '-2') {
            this.error = "Atención: Ya existe otro menú con el mismo nombre";
          } else {
            this.error = "Atención: Ya existe otro menú con el mismo identificador y nombre";
          }
          this.errorValidacionCreacionMenu = true;
        } else {
          this.irPaginaInicio();
        }
        this.loading = false;
      } else {
        this.loading = false;
        alert("Ocurrió un error, intente nuevamente más tade");
      }
    } else {
      this.errorValidacionCreacionMenu = true;
    }

  }


  asignarValorArea() {
    this.gafuAreaFuncional = this.areaFuncionalSeleccionada ? this.areaFuncionalSeleccionada.areaFuncional : "";
  }
  keyPressAlphaNumericWithCharacters(event) {
    var inp = String.fromCharCode(event.keyCode);
    // Allow numbers, alpahbets,, undercore
    if (/[a-zA-Z0-9-_]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  onPaste(e) {
    e.preventDefault();
    return false;
  }


  isCreateMenuDataValid() {
    this.error = "";
    if (this.codigoAsistente && this.descripcion && this.nombre && this.areaFuncional) {
      //debugger
      if (this.codigoAsistente.length > 60) {
        this.error = "Atención: El código del asistente no puede superar los 60 caracteres";
        return false;
      } else {
        if (/\s/.test(this.codigoAsistente)) {
          this.error = "Atención: El código no puede contener espacios en blanco";
          return false;
        } else {
          let isValid = /[a-zA-Z0-9-_]/.test(this.codigoAsistente);
          if (!isValid) {
            this.error = "Atención: El código no puede contener caracteres especiales. Solo se admiten números, letras y los caracteres - y _";
            return false;
          }
        }
      }

      if (this.nombre.length > 60) {
        this.error = "Atención: El nombre del menú no puede superar los 60 caracteres";
        return false;
      }
      if (this.descripcion.length > 250) {
        this.error = "Atención: La descripción del menú no puede superar los 250 caracteres";
        return false;
      }
      if (this.areaFuncional.length > 20) {
        this.error = "Atención: El código de área funcional del menú no puede superar los 20 caracteres";
        return false;
      }
      return true;
    } else {
      this.error = "Por favor, asegúrese de ingresar todos los campos obligatorios";
      return false;
    }
  }

  salirAdministrador() {
    this.menuService.salirAdministrador();
    this.router.navigate(["/login"]);
  }

  loadMenu(idMenu) {
    this.cargandoDatos = true;
    this.asistenteMenuService.loadMenuByID(idMenu).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        this.EsEdicion = true;
        let menuBD = data.content;
        //debugger
        this.codigoAsistente = menuBD.codigoAsistente;
        this.habilitado = menuBD.habilitado != null ? menuBD.habilitado : false;
        this.descripcion = menuBD.descripcion;
        this.nombre = menuBD.nombre;
        this.areaFuncional = menuBD.gafuAreaFuncional;
        for (let area of this.areasFuncionalesGAFU) {
          if (area.areaFuncional == this.areaFuncional) {
            this.areaFuncionalSeleccionada = area;
            break;
          }
        }
        this.cargandoDatos = false;
      }
      else {
        alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    },
      error => {
        alert(error);
        this.cargandoDatos = false;
      })
  }

  onSubmit() {
    this.isCreateMenuDataValid();
  }
}